import type { PiniaPluginContext } from 'pinia';

import cloneDeep from 'lodash/cloneDeep';
import { watch } from 'vue';

export default function resetStore({ pinia, store, options }: PiniaPluginContext): void {
  const initialState = cloneDeep(store.$state);
  store.$reset = () => store.$patch(cloneDeep(initialState));

  if (options.resetOnBrandChange) {
    watch(
      () => pinia.state.value.identity?.currentBrandLabel,
      () => store.$reset(),
    );
  }
}
